import './App.css';

function App() {
  return (
    <div className="App">
      <video className="video-play" controls autoplay="autoplay" object-fit="fill" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/assets/device_introduce.mp4" type="video/mp4">
      </video>
    </div>
  );
}

export default App;
